import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=b1607e16&"
import script from "./TextEditor.js?vue&type=script&lang=js&"
export * from "./TextEditor.js?vue&type=script&lang=js&"
import style0 from "./TextEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports